import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { mfaServices } from '../mfaServices'
import { MFAChallengeDTO, MFAChallengePayload } from '../mfaTypes'

import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export function useStartMFA(
  options?: IOptionsUseMutation<MFAChallengeDTO, MFAChallengePayload>,
) {
  const { t } = useTranslation()

  const mutation = useMutation<
    MFAChallengeDTO,
    ErrorDetail,
    MFAChallengePayload
  >({
    mutationFn: (data) => mfaServices.startMfa(data),
    onSuccess: (data, variables) => {
      if (options?.onSuccess) {
        options.onSuccess(data, variables)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)

      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (options?.onError) {
        options?.onError({ ...err, errorMessage, code })
      }
    },
  })

  return { ...mutation }
}
